import axios from 'axios';
import { FINGERPRINT_AUTH_SERVER_URL, NGOROMSO_SERVER_URL } from '../constants/Common';

export const fingerAuthAPI = axios.create({
    baseURL: `${FINGERPRINT_AUTH_SERVER_URL}/`,
    responseType: "json"
  });
  
  // Second instance
  export const ngoromsoAPI = axios.create({
    baseURL: `${NGOROMSO_SERVER_URL}`,
    headers: {
      'Content-Type': 'application/json'
    }
  });